<template>
  <a-modal title="修改密码" :width="600" :visible="visible" @cancel="handleCancel"
           :maskClosable="!required"
           :closable="!required"
           :keyboard="!required">
    <template slot="footer">
      <a-button type="gary" @click="handleCancel" v-show="!confirmLoading">{{required ? '关闭并退出':'取消'}}</a-button>
      <a-button type="primary" @click="handleOkChangePwd" :disabled="confirmLoading">确定</a-button>
    </template>

    <a-form layout="vertical" :form="form" class="change-pwd-form">
      <a-form-item v-if="required">
        <a-alert type="warning" show-icon message="为了账户安全，请先修改您的默认密码！"/>
      </a-form-item>
      <a-form-item label="原密码">
        <a-input-password placeholder="请输入原密码" type="password"
                          v-decorator="['password', { rules: [{ required: true, message: '请输入原密码！' }] }]"/>
      </a-form-item>
      <a-form-item label="新密码">
        <a-input-password placeholder="请输入新密码" type="password"
                          v-decorator="['newPassword', { rules: [{ required: true, message: '请输入新密码！' }, { validator: validatorPassword }] }]"/>
      </a-form-item>
      <a-form-item label="确认新密码">
        <a-input-password placeholder="请再次输入新密码" type="password"
                          v-decorator="['confirm', { rules: [{ required: true, message: '请再次输入新密码！' }, { validator: compareToFirstPassword }] }]"/>
      </a-form-item>
      <a-alert type="warning" show-icon :message="changePwdTips" class="change-pwd-tips"/>
    </a-form>
  </a-modal>
</template>

<script>
import {updatePassword} from '@/api/contacts/contactsEmp'
import {mixinValidator} from '@/utils/mixin';

export default {
  data() {
    return {
      labelCol: {
        xs: {span: 24},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      },
      confirmLoading: false,
      visible: false,
      userId: '',
      form: this.$form.createForm(this),
      changePwdTips: '温馨提示：密码长度为8-16个字符，且必须包含大、小写字母及数字'
    }
  },
  mixins: [mixinValidator],
  props: {
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleOkChangePwd() {
      const {form: {validateFields}} = this
      this.confirmLoading = true
      validateFields((errors, values) => {
        if (!errors) {
          if (this.$store.getters.userInfo.id) {
            values.id = this.$store.getters.userInfo.id
          } else {
            console.log('登录已过期, 请刷新页面重试')
            this.confirmLoading = false
            return;
          }
          updatePassword(values).then((res) => {
            if (res.success) {
              this.$message.success('密码修改成功，即将重新登录...', 1500, this.$store.dispatch('Logout').then(() => {
                setTimeout(() => {
                  window.location.reload()
                }, 2500)
              }))
            } else {
              this.$message.error('修改失败 ', +res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          });
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
      if(this.required){
        this.$store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 500)
        })
      }
    },
    compareToFirstPassword(rule, value, callback) {
      if (value && value !== this.form.getFieldValue('newPassword')) {
        callback('与输入的新密码不一致！')
      } else {
        callback()
      }
    },

  }
}
</script>
<style scoped lang="less">
.change-pwd-form {
  margin-top: -5px;

  /deep/ .ant-form-item {
    padding-bottom: 0;

    &:not(:nth-child(3)) {
      margin-bottom: 20px;
    }
  }

  .change-pwd-tips {
    background-color: #fff7e8;
    border-radius: 3px;
    border: 0;
    padding: 11px 15px 11px 37px;
    margin-bottom: 30px;

    /deep/ .ant-alert-icon {
      top: 16px;
      color: #ffb11a;
    }

    /deep/ .ant-alert-message {
      line-height: 24px;
      color: #ffb11a;
    }
  }
}
</style>
